import React,{useRef,useState} from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { CardMedia, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import AppleIcon from "@mui/icons-material/Apple"; // For macOS
import ComputerIcon from "@mui/icons-material/Computer"; // Replacing WindowsIcon
import WindowSharpIcon from "@mui/icons-material/WindowSharp";
import megabluelogo from "../../assets/images/megaconnectbluelogo.png";
import megawhitelogo from "../../assets/images/megaconnectwhitelogo.png";
import TerminalIcon from "@mui/icons-material/Terminal"; // Replacing LinuxIcon
import { Link } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TopBar from "../CustomerOnboarding/TopBar";
import playstore from "../../assets/images/mage_playstore.png";
import Iconify from "../iconify";
import {varZoom } from "../animate";
import { m } from "framer-motion";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

export default function DownloadWindow() {
  const [showGuide, setShowGuide] = React.useState(false);
  const [openPopup, setOpenPopup] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState(false);

  // Handle screen size change
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600); // Mobile screen size check
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial screen size check

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleGuideToggle = () => {
    setShowGuide((prev) => !prev);
  };
  const handleDownload = () => {
    if (isMobile) {
      setOpenPopup(true); // Open popup on mobile
    } else {
      const link = document.createElement("a");
      link.href = `${process.env.PUBLIC_URL}/MegaConnect_Installer_64bit.zip`; // Replace with actual file URL
      link.download = "MegaConnect_Installer_64bit.zip";
      link.click();
    }
  };
  const handleClosePopup = () => {
    setOpenPopup(false); // Close the popup
  };

  const [openGuideDialog, setOpenGuideDialog] = React.useState(false);

  // Function to handle opening the dialog
  const handleGuideOpen = () => {
    setOpenGuideDialog(true);
  };

  // Function to handle closing the dialog
  const handleGuideClose = () => {
    setOpenGuideDialog(false);
  };

  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  const getVideoHeight = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 600) {
        return 'auto'; // Mobile
    } else if (screenWidth > 600 && screenWidth <= 1024) {
        return '500px'; // Tablet
    } else {
        return '300px'; // Desktop
    }
};
  return (
    <>
      <TopBar />
      <Box
        sx={{
          minHeight: "85vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#F8F9FE",
          padding: { xs: "10px", sm: "20px" },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: "#1E53E8",
            fontWeight: 600,
            textAlign: "center",
            marginBottom: "10px",
            fontSize: { xs: "24px", sm: "28px", md: "32px" },
          }}
        >
          CONGRATULATIONS{" "}
          <span role="img" aria-label="celebration">
            🎉
          </span>
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#4F4F4F",
            textAlign: "center",
            marginBottom: "40px",
            fontSize: { xs: "14px", sm: "16px" },
          }}
        >
          You've successfully completed the process. To start using the service,
          please download the application.
        </Typography>

        <Grid
          container
          spacing={3}
          justifyContent="center"
          sx={{ maxWidth: "1200px", width: "100%" }}
        >
          {/* Card for Windows */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              sx={{
                color: "#1D53E7",
                fontFamily: "Roboto Flex",
                fontSize: { xs: "14px", sm: "16px" },
                fontWeight: 600,
                fontStyle: "italic",
                lineHeight: "26px",
                textAlign: "center",
              }}
            >
              For Children’s
            </Typography>
            <Card
              sx={{
                marginTop: "10px",
                borderRadius: "20px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
                padding: "20px",
                transition: "transform 0.3s",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            >
              <CardContent>
                <CardMedia
                  component="img"
                  image={megabluelogo} // Replace with your image path
                  alt="Windows Application"
                  sx={{
                    width: "60px",
                    height: "60px",
                    margin: "0 auto",
                    color: "#1E53E8",
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    marginTop: "10px",
                    fontSize: { xs: "16px", sm: "18px", md: "20px" },
                    fontFamily: "Roboto Flex",
                  }}
                >
                  Cloud PC
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "16px", sm: "18px", md: "20px" },
                    fontFamily: "Roboto Flex",
                  }}
                >
                  Application
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    marginTop: "20px",
                    backgroundColor: "#1E53E8",
                    color: "#FFFFFF",
                    textTransform: "none",
                    fontSize: { xs: "14px", sm: "16px" },
                    "&:hover": {
                      backgroundColor: "#1749C7",
                    },
                  }}
                  onClick={handleDownload}
                >
                  <WindowSharpIcon
                    sx={{ fontSize: 24, color: "white", marginRight: "8px" }}
                  />
                  Download
                </Button>
              </CardContent>
            </Card>
          </Grid>
          {/* Card for Windows */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              sx={{
                color: "#1D53E7",
                fontFamily: "Roboto Flex",
                fontStyle: "italic",
                fontSize: { xs: "14px", sm: "16px" },
                fontWeight: 700,
                lineHeight: "26px",
                textAlign: "center",
              }}
            >
              For Parent’s
            </Typography>
            <Card
              sx={{
                marginTop: "10px",
                borderRadius: "20px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
                padding: "20px",
                transition: "transform 0.3s",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            >
              <CardContent>
                <CardMedia
                  component="img"
                  image={megawhitelogo} // Replace with your image path
                  alt="Windows Application"
                  sx={{
                    width: "60px",
                    height: "60px",
                    margin: "0 auto",
                    color: "#1E53E8",
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    marginTop: "10px",
                    fontSize: { xs: "16px", sm: "18px", md: "20px" },
                    fontFamily: "Roboto Flex",
                  }}
                >
                  Parental Monitoring
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "16px", sm: "18px", md: "20px" },
                    fontFamily: "Roboto Flex",
                  }}
                >
                  Application
                </Typography>

                <Button
                  variant="contained"
                  sx={{
                    marginTop: "20px",
                    backgroundColor: "#1E53E8",
                    color: "#FFFFFF",
                    textTransform: "none",
                    fontSize: { xs: "14px", sm: "16px" },
                    "&:hover": {
                      backgroundColor: "#1749C7",
                    },
                  }}
                  component="a" // Make the button behave like a link
                  href="https://play.google.com/store/apps/details?id=com.megaconnect.Megaconnect_parental" // Replace with the URL you want to redirect to
                  target="_blank" // Optional: Opens the link in a new tab
                  rel="noopener noreferrer" // For security reasons, especially with `target="_blank"`
                >
                  <img
                    src={playstore}
                    alt="Play Store"
                    style={{
                      width: "24px",
                      height: "24px",
                      marginRight: "8px",
                    }} // Adds a gap between the image and text
                  />
                  Download
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Box
          sx={{
            marginTop: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: "0 20px",
          }}
        >
          <Link
            to="/dashboard"
            style={{
              textDecoration: "none",
              color: "#1E53E8",
              fontWeight: 600,
              fontFamily: "Roboto Flex",
              fontSize: "18px",
            }}
          >
            <Button
              variant="contained"
              className="btnTxt"
              fullWidth
              sx={{
                textTransform: "none",
                p: "10px 15px",
                transition: "background-color 0.3s, transform 0.3s",
                "&:hover": {
                  backgroundColor: "#A1D34F",
                  transform: "scale(1.05)",
                },
                "&:active": {
                  backgroundColor: "#9BCC4E",
                  transform: "scale(1)",
                },
              }}
            >
              Go to Dashboard
            </Button>
          </Link>
          <Button
            onClick={handleGuideOpen}
            sx={{
              textDecoration: "none",
              color: "#1E53E8",
              fontWeight: 600,
              textTransform: "none",
              fontFamily: "Roboto Flex",
              fontSize: { xs: "16px", sm: "18px" },
            }}
          >
            Installation Guide
          </Button>
        </Box>

       

        {/* Popup Modal for installation notice for mobile view  */}

        <Dialog
          open={openPopup}
          onClose={handleClosePopup}
          maxWidth={false}
          disableEscapeKeyDown // Prevent closing with the Escape key
          PaperProps={{
            sx: {
              maxWidth: 720,
              minWidth: { xs: 250, lg: 468 },
              borderRadius: 5,
              p: { md: "38px", xs: "28px" },
            },
          }}
        >
          <DialogTitle
            sx={{
              color: "#1D53E7", // Title color
              textAlign: "center", // Center-align the title text
              fontFamily: "Roboto Flex",
              fontWeight: "700",
              lineHeight: "30px",
              wordWrap: "break-word",
            }}
          >
            Installation Notice for Megaconnect App
            <IconButton
              onClick={handleClosePopup}
              sx={{
                position: "absolute",
                top: 15,
                right: 15,
                backgroundColor: "#f1f1f1",
                color: "#919191",
                transition: "color 0.3s ease",
                "&:hover": {
                  color: "red",
                },
              }}
            >
              <Iconify icon="material-symbols:close" />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              // display: 'flex',
              flexDirection: "column",
              alignItems: "center", // Center-align the content
              justifyContent: "center", // Center-align the content vertically
              fontFamily: "Roboto Flex", // Set font to Roboto Flex
              fontWeight: 600, // Set font weight
              fontSize: "22px", // Set font size
              lineHeight: "32px", // Set line height
              textAlign: "center", // Center-align text inside content
            }}
          >
            <Typography>
              For the best experience, please install the Megaconnect app on
              your Windows PC.
            </Typography>
          </DialogContent>
        </Dialog>


      {/* Dialog for displaying the video guide */}
      <Dialog
        open={openGuideDialog}
        onClose={handleGuideClose}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            maxWidth: 720,
            minWidth: { xs: 250, lg: 468 },
            borderRadius: 5,
            p: { md: "38px", xs: "28px" },
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600,color:"#1D53E7" }}>
            Installation Guide
          </Typography>
          <IconButton
              onClick={handleGuideClose}
              sx={{
                position: "absolute",
                top: 15,
                right: 15,
                backgroundColor: "#f1f1f1",
                color: "#919191",
                transition: "color 0.3s ease",
                "&:hover": {
                  color: "red",
                },
              }}
            >
              <Iconify icon="material-symbols:close" />
            </IconButton>
        </Box>

        <DialogContent>
          {/* Embedding a video with autoplay */}
          <Box
          sx={{
            position: "relative",
            // width: '100%',
            // maxWidth: '800px',
            m: { md: 0, sm: "25px 0px", xs: "25px 0px" },
            p: { md: "40px", sm: 0, xs: 0 },
          }}
          component={m.div}
          variants={varZoom({ distance: 80, durationIn: 0.9 }).in}
        >
          <video
            ref={videoRef}
            width="100%"
            height={getVideoHeight()}
            // height="auto"
            style={{ borderRadius: 15, border:'1px solid blue' }}
            onClick={handlePlayPause}
            controls={isPlaying}
            muted // Start muted; unmute when video is in view
            autoPlay
            loop
          >
            <source src="/assets/installation_guide.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {!isPlaying && (
            <Button
              onClick={handlePlayPause}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: "#fff",
                borderRadius: "50%",
                padding: "10px",
                minWidth: "60px",
                minHeight: "60px",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.7)",
                },
              }}
            >
              <PlayArrowIcon fontSize="large" />
            </Button>
          )}
        </Box>
        </DialogContent>
      </Dialog>
      </Box>
    </>
  );
}
